
const digest = '31f031958054f047046c45885d883a5528ec892c142e53c3abd6b6f7924b082b';
const classes = {"wrapper":"_wrapper_zqtq0_1","cancelledTag":"_cancelledTag_zqtq0_5"};
const css = `._wrapper_zqtq0_1 {
  padding: 12px;
}

._cancelledTag_zqtq0_5 {
  color: #d81616;
  border-color: #d81616 !important;
  font-size: 80%;
  display: inline-block;
  margin-left: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  